export default __webpack_public_path__ + "static/media/Playfair.7b3e1e40.ttf";